
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/credit-bureau-consolidation",
      function () {
        return require("private-next-pages/use-cases/credit-bureau-consolidation.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/credit-bureau-consolidation"])
      });
    }
  